<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import type { User } from '../../../modules/usersApi/users/user'
    import type { Service } from '../../../modules/posApi/services/service'
    import { faUser } from '@fortawesome/free-solid-svg-icons'

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let users: User[] = await window.api.users.companies.getCompanyUsers(600)
        let services: Service[] = await window.api.pos.services.getAll({ type: 'all' }, 600)
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to, service: true, pageSize: 5000 })
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        console.log('relat.data', data)
        grid = new GridClass()
        grid.title = 'Pessoas que compraram - por item'
        grid.subtitle = 'Este relatório exibe valores declarados para cada item, mas não leva em consideração eventuais descontos aplicados globalmente no PDV.'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Cliente' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'Vendedor' }))
        grid.cols.push(new GridCol({ content: 'Item' }))
        grid.cols.push(new GridCol({ content: 'Valor comprado', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        for (const invoice of data) {
            for (let item of invoice.services) {
                if (!item.value) item.value = 0
                if (!item.quantity) item.quantity = 0
                item.service = services.find((el) => el.serviceId === item.serviceId)
                if (item.service?.type === 'package') continue
                item.user = users.find((el) => el.userId === item.userId)

                const btnEdit = new GridButton({
                    callback: () => window.person('show', invoice.personId),
                    icon: faUser,
                })

                let line: GridLine = new GridLine()
                line.slots.push({ content: invoice.createdAt })
                line.slots.push({ content: invoice['person']?.name })
                line.slots.push({ content: invoice['person']?.phone })
                line.slots.push({ content: item.user?.userName || '-' })
                line.slots.push({ content: item.service?.name || '-' })
                line.slots.push({ content: Math.round(item.value * item.quantity * 100) / 100 })
                line.slots.push({ content: [btnEdit] })
                grid.lines.push(line)
            }
        }
        console.log('relat.grid', grid)
        show = false
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
